// StyledErrorHead.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledErrorHeadBase = styled.label`
  outline: none;
  padding: ${({ styling }) => `${styling.errorHeadPaddingInline}px`};
  font-size: ${({ styling }) => `${styling.errorHeadFontSize}px`};
  font-weight: ${({ styling }) => styling.errorHeadFontWeight};
  font-family: ${({ styling }) => styling.errorHeadFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  margin: 0 0 ${({ styling }) => styling.errorHeadBottomSpacing}px;
  color: ${({ styling }) => styling.errorHeadColor};
  background: ${({ styling }) => styling.errorHeadBackground};
  width: 100%;
  display: block;

`;

const StyledErrorHead = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledErrorHeadBase {...props} placeholder={placeholderText} />;
};



export default StyledErrorHead;
